import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: 'app-confirmation-alert',
  templateUrl: './confirmation-alert.component.html',
  styleUrls: ['./confirmation-alert.component.scss'],
  standalone: false
})

export class ConfirmationAlertComponent {
  @Input() isOpen: boolean = false;
  @Input() message: string = 'Please, confirm that you want to delete added content.';
  @Output() confirm = new EventEmitter<any>();

  buttons: any[] = [
    {
      text: 'Cancel',
      cssClass: 'primary two-buttons cancel-button',
      icon: "checkmark-circle",
      handler: (data: any) => {
        this.confirm.emit(false);
      }
    },
    {
      text: 'Delete',
      cssClass: 'red two-buttons delete-button',
      handler: (data: any) => {
        this.confirm.emit(true);
      }
    }
  ];

  constructor() {
  }

  onDidDismiss() {
    this.confirm.emit('');
  }
}
